import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import DatasetsListPage from 'features/datasets/pages/DatasetsListPage';
import DatasetDetailPage from 'features/datasets/pages/DatasetDetailPage';

/**
 * DatasetsPage — sub-router for `/:team/datasets/*`.
 *   /:team/datasets        → list
 *   /:team/datasets/new    → an unsaved draft (created on first save)
 *   /:team/datasets/:id    → dataset detail (rows, sources, labeling, export)
 */
export default function DatasetsPage() {
  const { team } = useParams();
  const { pathname } = useLocation();
  const base = `/${encodeURIComponent(team)}/datasets`;
  const after = pathname.startsWith(base)
    ? pathname.slice(base.length).replace(/^\/+/, '').replace(/\/+$/, '')
    : '';
  const parts = after ? after.split('/') : [];

  if (parts.length === 0) return <DatasetsListPage />;
  return <DatasetDetailPage datasetId={parts[0]} />;
}
